import { render } from "./Nazarite.vue?vue&type=template&id=2bc7516a&scoped=true"
import script from "./Nazarite.vue?vue&type=script&lang=js"
export * from "./Nazarite.vue?vue&type=script&lang=js"

import "./Nazarite.vue?vue&type=style&index=0&id=2bc7516a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc7516a"]])

export default __exports__